const axios = require("axios");
const { getBaseUrl } = require("./baseUrl");

/* NodeJS */
module.exports = {
  getFulfillment: (propertyUid, lobbyRowId, fulfillmentId, language) =>
    getBaseUrl().then((url) =>
      axios({
        method: "GET",
        url: `${url}/fulfillment?language=${language}&property_uid=${propertyUid}&lobby_row_id=${lobbyRowId}&fulfillment_id=${fulfillmentId}`,
      })
    ),
};